import { Sparkles, ShieldCheck, Armchair, PanelTop, Cog, CircleDot, Lightbulb, Droplets, Wrench } from "lucide-react";

const MAP = {
  Sparkles,
  ShieldCheck,
  Armchair,
  PanelTop,
  Cog,
  CircleDot,
  Lightbulb,
  Droplets,
};

export function getIcon(name) {
  return MAP[name] || Wrench;
}
